// extracted by mini-css-extract-plugin
export default {"logo":"Navbar_logo__MK0b0","container":"Navbar_container__dA4Dw","back":"Navbar_back__XJPG4","inner":"Navbar_inner__HvthE"};